import React, { ReactNode } from 'react';

import NoticeBig from '../../modules/notice-big/notice-big';
import TableHeaderWrapper from '../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';

import ErrorIcon from './icons/error.svg';
import SuccessIcon from './icons/success.svg';

import './order-sign-result.scss';

interface OrderSignResultProps {
  title?: string;
  text?: string;
  linkContent?: React.ReactNode;
  submitBtn: React.ReactNode;
  success: boolean;
  loading: boolean;
  onClose?: () => void;
  successIcon?: ReactNode;
  tableHeader?: string;
}

const SuccessContent = (
  <>
    Вы&nbsp;успешно подписали выбранные реализации, вы&nbsp;можете скачать
    подписанные документы или найти их&nbsp;в&nbsp;разделе&quot;Документы&quot;
  </>
);

const ErrorContent = <>Произошла ошибка</>;

const OrderSignResult: React.FC<OrderSignResultProps> = ({
  submitBtn,
  onClose,
  loading,
  success,
  linkContent,
  title,
  text,
  successIcon,
  tableHeader,
}) => (
  <TableWrapper>
    <div className="page-blank">
      <div className="page-blank__header">
        <TableHeaderWrapper
          onCloseClick={onClose}
          leftContent={tableHeader || 'Результат подписания'}
        />
      </div>
      <div className="page-blank__body">
        {!loading ? (
          <>
            {success ? (
              <NoticeBig
                title={title || 'Успешное подписание!'}
                bottom={submitBtn}
                icon={successIcon || SuccessIcon}
                text={text || SuccessContent}
                link={linkContent}
              />
            ) : (
              <NoticeBig
                text={ErrorContent}
                link=""
                icon={ErrorIcon}
                title="Внимание ошибка!"
                bottom={submitBtn}
              />
            )}
          </>
        ) : null}
      </div>
    </div>
  </TableWrapper>
);

export default OrderSignResult;
